import React from 'react';

import {
  ImagePresentational,
  LinkPresentational,
  TitleBodyImageLinkBlockPresentational,
} from '../../types/common';
import {
  BlogArticleBlockItem,
  Props as BlogArticleBlockItemProps,
} from '../BlogArticleBlockItem/BlogArticleBlockItem';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';
import { ContentPagesSection } from '../ContentPagesSection/ContentPagesSection';
import { DangerouslySetInnerHtml } from '../DangerouslySetInnerHtml/DangerouslySetInnerHtml';
import { HomeArrowLink } from '../HomeArrowLink/HomeArrowLink';
import { LayoutWidth, LayoutWrapper } from '../LayoutWrapper/LayoutWrapper';
import { TopBlockWithImage } from '../TopBlockWithImage/TopBlockWithImage';
import { Typography } from '../Typography/Typography';
import styles from './LandingPageBody.module.css';

export type Props = {
  bottomBlocks: TitleBodyImageLinkBlockPresentational[];
  breadcrumbs: LinkPresentational[] | null;
  description: string | null;
  fullwidthBlocks: BlogArticleBlockItemProps[] | null;
  heroImage: ImagePresentational | null;
  title: string;
};

export const LandingPageBody = React.memo((props: Props) => {
  const {
    heroImage,
    title,
    fullwidthBlocks,
    description,
    breadcrumbs,
    bottomBlocks,
  } = props;

  return (
    <div className={styles.landingPageBody}>
      <TopBlockWithImage
        image={heroImage}
        backLink={
          <HomeArrowLink />
        }
      />

      <LayoutWrapper size={LayoutWidth.Narrow}>
        <Typography className={styles.title} variant='h1'>
          {title}
        </Typography>
        <DangerouslySetInnerHtml
          variant={'body2'}
          className={styles.description}
          dangerousHtml={description ?? ''}
        />

      </LayoutWrapper>

      {fullwidthBlocks?.length ? fullwidthBlocks.map((block, index) => (
        <BlogArticleBlockItem
          key={index}
          title={block.title}
          withHandBlockTitle={block.withHandBlockTitle}
          withHandBlockLink={block.withHandBlockLink}
          withHandBlockDescription={block.withHandBlockDescription}
          withHandBlockCardImage={block.withHandBlockCardImage}
          withHandBlockIsShowHand={block.withHandBlockIsShowHand}
          withHandBlockBackgroundImage={block.withHandBlockBackgroundImage}
          coloredBlocks={block.coloredBlocks}
          firstDescription={block.firstDescription}
          secondDescription={block.secondDescription}
          image={block.image}
          isLandingPage
          withHandBlockIsShowShadow={block.withHandBlockIsShowShadow}
        />
      )) : null}

      <ContentPagesSection items={bottomBlocks} />

      <Breadcrumbs breadcrumbs={breadcrumbs} />
    </div>
  );
});

LandingPageBody.displayName = 'LandingPageBody';
